var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "estudologia-cap-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sumari-form",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-1005.000000, -341.000000)",
    stroke: "#4A4A49",
    fill: "#3C3C3B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(812.000000, 140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(194.000000, 202.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2568359,0 L21.5136719,5.25683594 L21.5136719,17.0847168 C21.5136719,17.4543399 21.3870436,17.765777 21.1337833,18.0190372 C20.8805231,18.2722975 20.569086,18.3989258 20.1994629,18.3989258 L15.5997314,18.3989258 L15.5997314,17.0847168 L20.1994629,17.0847168 L20.1994629,6.57104492 L14.942627,6.57104492 L14.942627,1.31420898 L7.71447754,1.31420898 C7.71447754,0.944585859 7.84110578,0.633148824 8.09436607,0.379888535 C8.34762636,0.126628245 8.6590634,0 9.02868652,0 L16.2568359,0 Z M16.2568359,5.25683594 L19.645031,5.25683594 L16.2568359,1.84810638 L16.2568359,5.25683594 Z M1.80053711,2.62841797 L9.02868652,2.62841797 L14.2855225,7.88525391 L14.2855225,19.7131348 C14.2855225,20.0827579 14.1588942,20.3941949 13.9056339,20.6474552 C13.6523736,20.9007155 13.3409366,21.0273437 12.9713135,21.0273437 L1.80053711,21.0273437 C1.43091398,21.0273437 1.11947695,20.9007155 0.86621666,20.6474552 C0.61295637,20.3941949 0.486328125,20.0827579 0.486328125,19.7131348 L0.486328125,3.94262695 C0.486328125,3.57300383 0.61295637,3.26156679 0.86621666,3.0083065 C1.11947695,2.75504621 1.43091398,2.62841797 1.80053711,2.62841797 Z M12.9713135,19.7131348 L12.9713135,9.19946289 L7.71447754,9.19946289 L7.71447754,3.94262695 L1.80053711,3.94262695 L1.80053711,19.7131348 L12.9713135,19.7131348 Z M9.02868652,7.88525391 L12.4168816,7.88525391 L9.02868652,4.47652435 L9.02868652,7.88525391 Z",
    id: "Docs---simple-line-icons"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapIcon);
export default __webpack_public_path__ + "static/media/cap-icon.3249fd82b1920c1390d6c2e65ad179aa.svg";
export { ForwardRef as ReactComponent };